const uuidPattern =
  /[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}/gi;

export function countUuidsInMessage(message: string): number {
  return message.match(uuidPattern)?.length ?? 0;
}

interface ApiErrorBody {
  title?: string;
  detail?: string;
  status?: number;
}

export async function parseApiError(
  error: unknown,
  fallback = 'Upload failed',
): Promise<Error> {
  try {
    const response =
      error instanceof Response
        ? error
        : (error as {response?: Response}).response;

    if (response instanceof Response) {
      const body = (await response.json()) as ApiErrorBody;
      const message = body.detail ?? body.title ?? fallback;
      return new Error(message);
    }
  } catch {
    // JSON parsing failed — fall through to generic message
  }

  if (error instanceof Error) return error;
  return new Error(fallback);
}
